import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { timeZone } from 'src/app/utils/utils.common';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
@UntilDestroy()

@Component({
  selector: 'app-member-trips-modal',
  templateUrl: './member-trips-modal.component.html',
  styleUrls: ['./member-trips-modal.component.css']
})
export class MemberTripsModalComponent implements OnInit {
  @Input() memberDetails:any;
  @Output() closeModal = new EventEmitter<any>()
  currentPage = 1;
  memberTrips:any = [];
  preLevelOfServiceList:any = {}
  preSpaceTypeList:any = {}
  preAppointmentTypes:any = {}
  fundingSource: any;
  preFundingSource: any = {}
  levelofservices:any
  PrelevelofService:any;
  membersAppointment:any;
  preMembersAppointment:any;
  companies: any;
  preCompanies: any;
  todayDate:any = [];
  user:any
  timeZone: any = timeZone;
  selectedStatus:any = 'all';
  totalPages = 0;
  totalResults = 0;

  trips:any;
  constructor(
    private sharedDataService: SharedDataService,
    private tripService :  TripService,
    private memberService : MemberService,
    private appointmentType: AppointmentTypeService,
    private levelOfService: LosService,
    private spaceType: SpaceTypeService,
    private fundingSourceService: FundingSourceService,
    private credentialService: CredentialService
  ){}
  ngOnInit(): void {
    this.getUser();
    this.getLevelOfService();
    this.getAppointmentTypes();
    this.getSpaceTypes();
    this.getFundingSources();
    this.getAllCompanies();
    this.getMemberTrips(this.currentPage)
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).add(7, "days").endOf("day").toDate()
        ];
      }
    })
  }

  getMemberTrips(page: any) {
    let queryparams = {
      limit: 50,
      page,
      status:this.selectedStatus,
      member:this.memberDetails.id,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      sortBy: 'pickup.time:asc',
    }
    if (this.selectedStatus === 'all') {
      queryparams.status = [
        'pending',
        'scheduled',
        'offered',
        'onway',
        'arrived',
        'in_progress',
        'completed',
        'cancelled',
        'marketplace',
        'reroute'
      ];
    } else {
      queryparams.status = this.selectedStatus;
    }
    this.memberService.getMembersTrips(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
           if (this.memberTrips) {
             this.memberTrips = data.results;
    }
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
          this.currentPage = page;
      }
    })
  }


  getAppointmentTypes() {
    let queryParams = {
      limit: 9999,
      isActive: true
    }
    this.appointmentType.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results ) {
        this.membersAppointment = data.results;
        this.preMembersAppointment = this.membersAppointment.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    });
  }

  getLevelOfService() {
    let queryParams = {
      limit: 9999,
      isActive: true
    }
    this.levelOfService.getPicker(queryParams).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results ) {
          this.levelofservices = data.results;
          this.PrelevelofService = this.levelofservices.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  getSpaceTypes() {
    let queryParams = {
      limit: 9999,
      isActive: true
    }
    this.spaceType.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.preSpaceTypeList = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getFundingSources() {
    let queryParams = {
      limit: 9999,
      isActive: true
    } 
    this.fundingSourceService
      .getPicker(queryParams).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results ) {
          this.fundingSource = data.results;
          this.preFundingSource = this.fundingSource.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getAllCompanies() {
    let queryParams = {
      limit: 9999,
      isActive: true
    } 
    this.credentialService.getPicker(queryParams).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results ) {
          this.companies = data.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  getDateWiseTrips(evt:any){
    this.currentPage = 1;
    this.todayDate = evt;
    this.getMemberTrips(this.currentPage);
  }
  
  getpageWiseTrips(evt:any){
    this.currentPage = evt;
    this.getMemberTrips(this.currentPage);
  }

  getStatusiseTrips(evt:any){
     this.currentPage = 1;
    this.selectedStatus = evt;
    this.getMemberTrips(this.currentPage);
  }

  onStatusChange(status: string){
   this.selectedStatus = status
  }
}
